import React from 'react'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ErrorView } from '../../../../../views/error/ErrorView'
import { IllustrationChoices } from '../../../../common/Illustration'

interface BinderListEmptyStateProps {
  noSearchResults: boolean
  documentName?: string
  folderId?: string
}

export const BinderListEmptyState = ({
  documentName,
  noSearchResults,
  folderId,
}: BinderListEmptyStateProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  if (noSearchResults) {
    return (
      <ErrorView
        title={translate('binderList.emptyState.title')}
        subtitle={translate('binderList.emptyState.noSearchResultSubtitle')}
        illustration={IllustrationChoices.EMPTY}
      />
    )
  }

  return (
    <ErrorView
      title={translate('binderList.emptyState.title')}
      subtitle={
        folderId
          ? translate('binderList.emptyState.emptyFolderSubtitle', {
              folderName: documentName?.trim(),
            })
          : translate('binderList.emptyState.emptyBinder')
      }
      illustration={IllustrationChoices.EMPTY}
    />
  )
}
